import HeroSection from "./HeroSection.js";
import { Col, Row } from "react-bootstrap";
import "./InsightsSearchBlock.scss";
import PopularSearches from "./PopularSearches.js";
import WhyNeedInsights from "./WhyNeedInsights.js";
import QuoteSection from "./QuoteSection.js";

const InsightsSearchBlock = () => {
  return (
    <div className="InsightsSearchBlock">
      <Row>
        <Col>
          <HeroSection />
        </Col>
      </Row>
      <Row>
        <Col>
          <PopularSearches />
        </Col>
      </Row>
      <Row>
        <Col>
          <WhyNeedInsights />
        </Col>
      </Row>
      <Row>
        <Col>
          <QuoteSection />
        </Col>
      </Row>
    </div>
  );
};

export default InsightsSearchBlock;
